import { Component, inject } from '@angular/core';
import { SigninComponent } from '../signin.component';
import { first } from 'rxjs/operators';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/app/shared/alert.service';
import { AuthenticationService } from 'src/app/authentication/services/authentification.service';
import { MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import { MatButtonModule} from '@angular/material/button';
import { MatFormFieldModule, MatHint} from '@angular/material/form-field';
import { MatInputModule} from '@angular/material/input';
import { MatProgressSpinnerModule} from '@angular/material/progress-spinner'
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import checkPasswords from 'src/app/shared/checkPasswords';
import changePasswordValidator from 'src/app/shared/changePassword';
import { MatDivider } from '@angular/material/divider';
import { ToastrService } from 'ngx-toastr';

interface Forget{
  question : boolean;
  answer : boolean;
  change : boolean;
}

interface Account{
  username : string
  user_id : string
  question_id : string
  question : string
  token : string
}

@Component({
    selector: 'app-modal-signin',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        //material
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatDialogModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatButtonModule
    ],
    templateUrl: './modal-signin.component.html',
    styleUrl: './modal-signin.component.css'
})
export class ModalSigninComponent {
  loginForm: FormGroup = new FormGroup({});
  loading = false;
  loadingFP = false;
  submitted = false;
  btnMsg = "Envoyer ma reponse"
  returnUrl: string;
  myAccount : Account
  myPseudo : string = ''
  count_answer_request = 3
  readonly dialogRef = inject(MatDialogRef<SigninComponent>);

  change_password : Forget
  passwordForm : FormGroup = new FormGroup({})
  pseudoControl = new FormControl('')
  prenomControl = new FormControl('')
  answerControl = new FormControl('')

  labo : any = {};

  constructor(
      private formBuilder: UntypedFormBuilder,
      private route: ActivatedRoute,
      private router: Router,
      private authenticationService: AuthenticationService,
      private alertService: AlertService,
      private toastr : ToastrService,
      private fb : FormBuilder
  ) {
      // redirect to home if already logged in
      if (this.authenticationService.currentUserValue) {
          this.router.navigate(['/']);
      }
      this.change_password = {
        'question' : false,
        'answer' : false,
        'change' : false
      }

      this.passwordForm = this.fb.group({
        'password': ['',[Validators.minLength(8), Validators.required, changePasswordValidator]],
        'confirmPassword' : ['', []],
      }, {'validators': checkPasswords})
  }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });
      // get return url from route parameters or default to '/'
      this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/sigelam';
      this.labo = JSON.parse(localStorage.getItem('currentLabo'));

      this.pseudoControl.setValidators(Validators.required)
      this.prenomControl.setValidators(Validators.required)
      this.answerControl.setValidators(Validators.required)
  }


  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }

  onSubmit() {
      this.submitted = true;

      // reset alerts on submit
      this.alertService.clear();

      // stop here if form is invalid
      if (this.loginForm.invalid) {
          return;
      }

      this.authenticationService.login(this.f.username.value, this.f.password.value)
          .pipe(first())
          .subscribe(
              data => {
                this.alertService.success("Bienvenue " + data.user.nom + " !",true);
                this.router.navigate([this.returnUrl]);
              },
              error => {
                var message = ''
                if(error === 'Unauthorized'){
                  message = "Nom d'utilisateur ou mot de passe incorrect. Veuillez réessayer !"
                }
                else{
                    message = error
                }
                this.alertService.error(message);
                this.submitted = false;
              });
  }

  showHiden() {
    event.preventDefault();
    if($('#show_hide_password input').attr("type") === "text"){
      $('#show_hide_password input').attr('type', 'password');
      $('#show_hide_password mat-icon').text('visibility');
    }
    else if($('#show_hide_password input').attr("type") === "password"){
      $('#show_hide_password input').attr('type', 'text');
      $('#show_hide_password mat-icon').text( "visibility_off" );
    }
  }



  // forget password

  findQuestion(){
    this.loadingFP = true
    var user = {
      username : this.pseudoControl?.value,
      prenom : this.prenomControl?.value
    }
    this.authenticationService.findQuestion(user).subscribe({
      next : (res : any) =>{
        this.loadingFP = false
        this.myAccount = res
        this.change_password.question = true
      },
      error : (err) =>{
        this.loadingFP = false
        this.toastr.error('le pseudo est invalide ou inexistant')
      }
    })
  }

  giveAnswer(){

    var answer = {
      "user_id": this.myAccount.user_id,
      "verification_string": this.answerControl.value
    }
    const btnTitle = document.getElementById('confirmAnswerTilte')

    if(this.count_answer_request>0){
      this.loadingFP = true
      this.authenticationService.sendAnswer(answer).subscribe({
        next : (res : any) =>{
          this.loadingFP = false
          this.myAccount.token = res.token
          this.change_password.answer = true
          console.log(this.myAccount);

        },
        error : (err) =>{
          this.loadingFP = false

          if(err === "Invalid user or verification string"){
            this.count_answer_request--
            this.toastr.error("Reponse incorrecte !!!")

            if(this.count_answer_request == 0){
              var cpt = 10
              setTimeout(() => {this.toastr.info(`Veuillez réessayer dans 10 secondes !!!`)}, 2000);
              const Int = setInterval(() => {
                if(cpt==0)
                  clearInterval(Int)
                this.btnMsg = `réessayer dans ${cpt} secondes ...`
                cpt--
              }, 1000);

              setTimeout(() => {
                this.btnMsg = "Envoyer ma reponse"
                this.count_answer_request = 3
              }, 12000);
            }
          }
        }
      })
    }else{
       this.toastr.info("Veuillez réessayer dans 10 secondes !!!")
    }

    //
  }


  changePassword(){
    var change = {
        "user_id": this.myAccount.user_id,
        "token": this.myAccount.token,
        "new_password": this.passwordForm.get('password').value,
        "new_password_confirmation": this.passwordForm.get('confirmPassword').value
    }
    this.authenticationService.updatePassword(change).subscribe({
      next : (res : any) => {
        this.toastr.success(res.message)
        document.getElementById("closer").click()
        this.clearForgetPasswordForm()
      },
      error : (err) => {
        this.toastr.error(err)
        this.clearForgetPasswordForm()
      }
    })
  }

  clearForgetPasswordForm(){
    this.change_password = {
      'question' : false,
      'answer' : false,
      'change' : false
    }

    this.passwordForm.patchValue({password : '', confirmPassword : ''})
    this.pseudoControl.patchValue('')
    this.prenomControl.patchValue('')
    this.answerControl.patchValue('')
  }

}
